// @ts-nocheck
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { GetWishListApiParameter } from "@insite/client-framework/Services/WishListService";
import {
    CreateDataForUnparse,
    LoadRealTimePrices,
    PopulateApiParameter,
    RequestDataFromApi,
} from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/ExportWishList";
import translate from "@insite/client-framework/Translate";
import { WishListModel } from "@insite/client-framework/Types/ApiModels";
import {
    CreateDataForUnparseWithUpload,
    GenerateXLSXHandler,
} from "@store/Extensions/Store/Pages/MyListDetails/Handlers/ExportWishList";

export const chain = [
    PopulateApiParameter,
    RequestDataFromApi,
    LoadRealTimePrices,
    CreateDataForUnparseWithUpload,
    GenerateXLSXHandler("BuyingList"),
];

const exportBuyingList = createHandlerChainRunner(chain, "ExportBuyingList");
export default exportBuyingList;
